import produce from 'immer'
import { assign } from 'lodash'

import {
  FETCH_FOOD_MOOD,
  SET_FOOD_MOOD_PAGE_TO_DIRTY,
  UPDATE_FOOD_MOOD_IMAGE_DETAILS,
  UPDATE_FOOD_MOOD_RELATIONS_DETAILS,
  UPDATE_FOOD_MOOD_SIMPLE_DETAILS,
} from '../action-types'
import { FOOD_MOOD_INITIAL_STATE } from '../initial-states'

const foodMoodReducer = (state = FOOD_MOOD_INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_FOOD_MOOD_PAGE_TO_DIRTY:
      return produce(state, nextState => assign(nextState, action.payload))
    case FETCH_FOOD_MOOD.START:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: true,
          fetchError: undefined,
          data: [],
        }),
      )

    case FETCH_FOOD_MOOD.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: false,
          fetchError: undefined,
          data: action.payload.data.foodMood,
        }),
      )

    case FETCH_FOOD_MOOD.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: false,
          fetchError: action.error.message,
          data: [],
        }),
      )

    case FETCH_FOOD_MOOD.CLEANUP:
      return { ...FOOD_MOOD_INITIAL_STATE }

    case UPDATE_FOOD_MOOD_SIMPLE_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: true,
          simpleDetailsError: undefined,
        }),
      )

    case UPDATE_FOOD_MOOD_SIMPLE_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: false,
          simpleDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateFoodMoodSimpleDetails,
          ),
          isDirty: false,
        }),
      )

    case UPDATE_FOOD_MOOD_SIMPLE_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: false,
          simpleDetailsError: action.error.message,
        }),
      )

    case UPDATE_FOOD_MOOD_IMAGE_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: true,
          imageDetailsError: undefined,
        }),
      )

    case UPDATE_FOOD_MOOD_IMAGE_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: false,
          imageDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateFoodMoodImageDetails,
          ),
        }),
      )

    case UPDATE_FOOD_MOOD_IMAGE_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isImageDetailsLoading: false,
          imageDetailsError: action.error.message,
        }),
      )

    case UPDATE_FOOD_MOOD_RELATIONS_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isRelationsDetailsLoading: true,
          relationsDetailsError: undefined,
        }),
      )

    case UPDATE_FOOD_MOOD_RELATIONS_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isRelationsDetailsLoading: false,
          relationsDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateFoodMoodRelationsDetails,
          ),
        }),
      )

    case UPDATE_FOOD_MOOD_RELATIONS_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isRelationsDetailsLoading: false,
          relationsDetailsError: action.error.message,
        }),
      )

    default:
      return state
  }
}

export default foodMoodReducer
